import { filter } from 'rxjs/operators';
import { AppStateProvider } from 'src/app/services/app-state.provider';
import { DateService } from 'src/app/services/date.service';
import { InviteService } from './../../services/invite.service';
import {
  Component,
  OnInit,
  ElementRef,
  HostListener,
  OnDestroy,
} from '@angular/core';
import { Router } from '@angular/router';
import { ConfirmationDailogService } from 'src/app/company-module/shared/confirm-dailog/confirmation-dailog.service';
import { SidenavService } from 'src/app/services/sidenav.service';
import { Subscription } from 'rxjs';
import { DatePipe } from '@angular/common';
import { RolebasedactionService } from 'src/app/services/rolebasedaction.service';

@Component({
  standalone: false,
  selector: 'app-invite-approval',
  templateUrl: './invite-approval.component.html',
  styleUrls: ['./invite-approval.component.scss'],
})
export class InviteApprovalComponent implements OnInit, OnDestroy {
  private subscriptions = new Subscription();
  historyList: any[] = [];
  pendingList: any[] = [];
  openOptionDrawerPending: any[] = [];
  openOptionDrawerHistory: any[] = [];
  rejectionValue: any[] = [];
  submitted: any[] = [];
  error: any[] = [];
  globalIndex;
  globalIndex1;
  historySlice = 10;
  pendingSlice = 5;
  ViewMoreValue = 10;
  future: any;
  today: any;
  response: any;
  formattedDate: string;
  tempDate: any;
  selectedDate: any;
  selectedToDate: any;
  tempHistory: any[];
  vmsApprove: any;
  vmsReject: any;

  constructor(
    public datepipe: DatePipe,
    private router: Router,
    private inviteService: InviteService,
    private dateSrv: DateService,
    private el: ElementRef,
    private confirmService: ConfirmationDailogService,
    private appStateSrv: AppStateProvider,
    private sideNavService: SidenavService,
    private rolebasedactionService: RolebasedactionService,
  ) {
    localStorage.setItem('expandNav', 'true');
    const route = this.sideNavService.routingChunks({
      name: 'VMS Approval',
      subNav: '0',
      subNavLink: '/bulk-invite-approval',
    });
    this.appStateSrv.setSideNavState(route);
    this.GetVMSAccessPendingRequestList();
  }
  member: any = [];
  history: any = [];

  ngOnInit(): void {
    this.vmsApprove = this.rolebasedactionService.checkUserRolePermissionExits('VMS/Bulk Invite:Approve');
    this.vmsReject = this.rolebasedactionService.checkUserRolePermissionExits('VMS/Bulk Invite:Reject');
  }

  ngOnDestroy() {
    localStorage.removeItem('expandNav');
    this.subscriptions.unsubscribe();
  }

  @HostListener('click', ['$event'])
  captureClick(event) {
    this.openOptionDrawerHistory = this.openOptionDrawerHistory.map(
      (element, i) => {
        if (
          i === this.globalIndex1 &&
          (event.target.className === 'hc' ||
            event.target.className.includes('hc'))
        )
          return (element = true);
        return (element = false);
      }
    );
  }

  navigateToDetail(id) {
    localStorage.setItem('navigate', '0');
    this.router.navigate(['/bulk-invite-approval/details'], {
      queryParams: { id: id },
    });
  }

  GetVMSAccessPendingRequestList() {
    const jsDate = new Date();
    let yesterday = new Date();
    let future = new Date();
    yesterday.setDate(jsDate.getDate() - 30);
    future.setDate(jsDate.getDate());

    this.selectedDate = this.datepipe.transform(yesterday, 'MM/dd/yyyy');
    
    // this.selectedToDate = this.datepipe.transform(future, 'MM/dd/yyyy');
    this.selectedToDate = this.datepipe.transform(jsDate, 'MM/dd/yyyy');

    const data = {
      InvitationType: 'bulkInvite',
      ParkId: localStorage.getItem('parkId'),
    };
    const data1 = {
      resquestStatus: [],
      fromDate: this.selectedDate,
      toDate: this.selectedToDate,
      pageNo: 1,
      size: 10,
      invitationType: 'bulkInvite',
      parkTenantId: [],
      parkId: localStorage.getItem('parkId'),

      // userId: 636,
    };

    this.subscriptions.add(
      this.inviteService.getInvitationList(data).subscribe((res) => {
        this.pendingList = res.filter((ress) => ress.approvalDate == null);

        // this.historyList = res.filter( (ress) => ress.approvalDate !== null );
      })
    );

    this.subscriptions.add(
      this.inviteService.getHistoryDetail(data1).subscribe((res) => {
        // We initialize a past date
        const date2 = new Date('2018-04-07 12:30:00');
        // console.log(res.list)

        let temphistoryList = res.list.filter(
          (el) => new Date() > new Date(el.mstart) && el.isApproved == null
        );
        let tempHistory = res.list.filter((el) => el.isApproved !== null);
        this.historyList = temphistoryList.concat(tempHistory);

        this.historyList = this.historyList.sort((a, b) => a.mstart - b.mstart);
      })
    );
  }

  formatDate(date, type) {
    if (date == null) return;
    this.tempDate = date.split('T')[0].split('-');
    this.formattedDate = this.dateSrv.convertDateToLocaleString(
      this.tempDate[2],
      this.tempDate[1] - 1,
      this.tempDate[0]
    );
    if (type == 'date') return this.tempDate[2];
    if (type == 'month') return this.formattedDate.split(' ')[1];
    if (type == 'format')
      return (
        this.formattedDate.split(' ')[0] +
        ' ' +
        this.formattedDate.split(' ')[1] +
        ' ' +
        this.formattedDate.split(' ')[2]
      );
    if (type == 'formatDate') return this.formattedDate;
  }

  formatDateApproval(date, type) {

    if (date == null) return;
    if (type == 'date') {
      this.tempDate = date.split('T')[0].split('-');
      return this.dateSrv.convertDateToLocaleString(this.tempDate[2], this.tempDate[1] - 1, this.tempDate[0]);
    }
    if (type == 'time') {
      this.tempDate = date.split('T')[1].split(':');
      if (this.tempDate[0] == 12) {
        return this.tempDate[0] + ':' + this.tempDate[1] + ' ' + 'PM'
      }
      else {
        return this.tempDate[0] > 12 ? this.tempDate[0] - 12 + ':' + this.tempDate[1] + ' ' + 'PM' : this.tempDate[0] + ':' + this.tempDate[1] + ' ' + 'AM';
      }
      // return this.tempDate[0]>12? this.tempDate[0]-12 + ':' + this.tempDate[1] +' '+ 'PM':this.tempDate[0]+ ':' + this.tempDate[1] +' '+ 'AM';
    }
  }

  rejectRequest(invitationId, i, status) {
    if (status === false) {
      if (this.rejectionValue[i] == '' || this.rejectionValue[i] == undefined) {
        this.error[i] = true;
        return;
      }
      this.confirmService
        .confirm(
          'Please confirm..',
          'Are you sure, you want to reject this request ?',
          'Reject'
        )
        .then((confirmed) => {
          let body = {
            invitationId: invitationId,
            isApproved: status,
            remarks: this.rejectionValue[i],
          };
          this.subscriptions.add(
            this.inviteService.approveInvitation(body).subscribe((res) => {
              if (res.isValid) {
                this.closeAllPopups();
                this.GetVMSAccessPendingRequestList();
                this.rejectionValue[i] = '';
              }
            })
          );
        })
        .catch(() =>
          console.log(
            'User dismissed the dialog (e.g., by using ESC, clicking the cross icon, or clicking outside the dialog)'
          )
        );
    } else {
      this.confirmService
        .confirm(
          'Please confirm..',
          'Are you sure, you want to Approve this request ?',
          'Yes'
        )
        .then((confirmed) => {
          let body = {
            invitationId: invitationId,
            isApproved: status,
          };
          this.subscriptions.add(
            this.inviteService.approveInvitation(body).subscribe((res) => {
              if (res.isValid) {
                this.closeAllPopups();
                this.GetVMSAccessPendingRequestList();
              }
            })
          );
        })
        .catch(() =>
          console.log(
            'User dismissed the dialog (e.g., by using ESC, clicking the cross icon, or clicking outside the dialog)'
          )
        );
    }
  }

  checkValidation(i) {
    if (this.rejectionValue[i] != '' || this.rejectionValue[i] != undefined) {
      this.error[i] = false;
    }
  }

  closeAllPopups() {
    this.openOptionDrawerPending = this.openOptionDrawerPending.map(
      (element, i) => {
        return (element = false);
      }
    );
    this.openOptionDrawerHistory = this.openOptionDrawerHistory.map(
      (element, i) => {
        return (element = false);
      }
    );
  }

  viewMore() {
    this.pendingSlice = this.pendingList.length;
  }
  formatComment(remark) {
    console.log(remark);
    if (remark == 'Auto Rejected') {
      return 'Missed Approval';
    } else {
      return remark;
    }
  }
}
